import React from "react"
import { Link } from "gatsby"
import logo from "../../images/logo.svg"
import './assets/styles/_index.scss'

const HeaderLogo = () => {
    return (
        <Link to="/" className="navbar-brand"><img src={logo} alt={`Logo - ${process.env.GATSBY_SITE_NAME}`} className="logo-img" /></Link>
    )
}

export default HeaderLogo